import styles from './RadioVariantSelector.module.css'
import classnames from 'classnames'

export interface Radio {
  id: string
  value: string
}

interface RadioVariantSelectorProps {
  type: 'button' | 'text' | 'color'
  radio: Radio
  name: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const RadioVariantSelector = ({ type, radio, name, onChange }: RadioVariantSelectorProps) => {
  const radioVariantClasses = classnames(styles.RadioVariantSelector__button, {
    [styles[`RadioVariantSelector__button--button`]]: type === 'button',
  })
  const radioButtonColorClasses = classnames(styles[`RadioVariantSelector__button-color`], {
    [styles[`RadioVariantSelector__button-color--${radio.value}`]]: radio.value,
  })
  const radioButtonTextClasses = classnames(styles[`RadioVariantSelector__button-text`], {
    [styles[`RadioVariantSelector__button-text--button`]]: type === 'button',
  })

  return (
    <label className={styles.RadioVariantSelector} htmlFor={radio.id}>
      <input
        className={styles.RadioVariantSelector__input}
        id={radio.id}
        value={radio.id}
        name={name}
        type="radio"
        onChange={onChange}
      />
      <div className={radioVariantClasses}>
        {type === 'color' ? (
          <span className={radioButtonColorClasses} />
        ) : (
          <p className={radioButtonTextClasses}>{radio.value}</p>
        )}
      </div>
    </label>
  )
}
